import { Button, Skeleton, VStack, HStack } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import { Box, View } from 'native-base';
import React from 'react';

export const TermAcceptanceLoadingDesktop: React.FC = () => {
  return (
    <View minW="container" maxWidth={900} flex={1}>
      <VStack p="inline.xxxs" space="inline.xxs" flex={1}>
        <VStack space="stack.xxxs">
          <Skeleton height="28px" width="180px" borderRadius={BoxRadius.sm} />
          <Box h="1px" bg="neutral.lightest" />
          <VStack space="stack.nano">
            <HStack justifyContent="space-between">
              <Skeleton height="16px" width="72px" borderRadius={BoxRadius.sm} />
              <Skeleton height="16px" width="160px" borderRadius={BoxRadius.sm} />
            </HStack>
            <Box h="1px" bg="neutral.lightest" />
            <HStack justifyContent="space-between">
              <Skeleton height="16px" width="72px" borderRadius={BoxRadius.sm} />
              <Skeleton height="16px" width="96px" borderRadius={BoxRadius.sm} />
            </HStack>
          </VStack>
        </VStack>

        <VStack borderRadius={BoxRadius.sm} p="inline.xxxs" bg="neutral.white" space="stack.xxxs">
          <Skeleton height="16px" width="56px" borderRadius={BoxRadius.sm} />

          <Skeleton height="24px" width="78%" borderRadius={BoxRadius.sm} />

          <Box h="1px" bg="neutral.lightest" />

          <VStack space="stack.nano">
            <HStack justifyContent="space-between">
              <Skeleton height="14px" width="52px" borderRadius={BoxRadius.sm} />
              <Skeleton height="14px" width="92px" borderRadius={BoxRadius.sm} />
            </HStack>
            <Box h="1px" bg="neutral.lightest" />
            <HStack justifyContent="space-between">
              <Skeleton height="14px" width="86px" borderRadius={BoxRadius.sm} />
              <Skeleton height="14px" width="88px" borderRadius={BoxRadius.sm} />
            </HStack>
            <Box h="1px" bg="neutral.lightest" />
            <HStack justifyContent="space-between">
              <Skeleton height="14px" width="112px" borderRadius={BoxRadius.sm} />
              <Skeleton height="14px" width="92px" borderRadius={BoxRadius.sm} />
            </HStack>
          </VStack>

          <VStack space="stack.quarck">
            <Skeleton height="14px" width="100%" borderRadius={BoxRadius.sm} />
            <Skeleton height="14px" width="92%" borderRadius={BoxRadius.sm} />
          </VStack>

          <HStack justifyContent="space-between" alignItems="center" py="stack.nano">
            <Skeleton height="16px" width="168px" borderRadius={BoxRadius.sm} />
            <Skeleton height="16px" width="16px" borderRadius={BoxRadius.sm} />
          </HStack>
        </VStack>
      </VStack>

      <HStack
        justifyContent="space-between"
        borderTopColor="neutral.lightest"
        borderTopWidth={1}
        p="inset.xs">
        <Button variant="secondary" w="48%" isDisabled>
          Recusar
        </Button>
        <Button w="48%" isDisabled>
          Aceitar
        </Button>
      </HStack>
    </View>
  );
};
